import { render, staticRenderFns } from "./releaseInfo.vue?vue&type=template&id=65698425&scoped=true&"
import script from "./releaseInfo.vue?vue&type=script&lang=js&"
export * from "./releaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./releaseInfo.vue?vue&type=style&index=0&id=65698425&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65698425",
  null
  
)

export default component.exports